<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>组织生活</el-breadcrumb-item>
				<el-breadcrumb-item>谈心谈话记录</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="contrl_bar">
						<el-button type="primary" 
						size="small"
						@click="$router.go(-1)">返回上级</el-button>
					</div>
					<div class="txthdetail">
						<div class="detail_title">{{title}}</div>
						<div class="others">
							<div class="others__left">
								<div><span>党组织：</span>{{formData.gu_name}}</div>
								<div><span>谈话人：</span>{{formData.uid1}}</div>
								<div><span>谈话对象：</span>{{formData.name2}}</div>
								<div><span>时间：</span>{{formData.day}}</div>
							</div>
							<div class="others__left">
								<div><span>地点：</span>{{formData.address}}</div>
							</div>
						</div>
						<div class="content">
							<div class="label">主要内容：</div>
							<div class="content_item" v-if="formData.content!=null && formData.content!=''" v-html="formData.content"></div>
							<div class="nodata" v-else>
								<img src="@/assets/images/nodata.jpg" >
							</div>
						</div>
						<div class="content">
							<div class="label">文件备案：</div>
							<div class="fileList" v-if="formData.files.length > 0">
								<div class="fileItem" v-for="(item,index) in formData.files">
									<div class="fileIcon" v-if="item.bsid == 8"><img src="@/assets/images/pdfBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 3"><img src="@/assets/images/videoBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 1"><img src="@/assets/images/pptBg.png" ></div>
									<div class="fileIcon" v-if="item.bsid == 2"><img src="@/assets/images/pdfBg.png" ></div>
									<div class="fileName">{{item.title}}</div>
									<div class="fileDel" title="删除" @click="downloadFile(item.ment_url)"><i class="el-icon-download"></i></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import txth_detaill from './mixins/txth_detaill.js'
	export default {
		mixins:[txth_detaill]
	}
</script>

<style lang="scss" scoped>
	@import './index.scss';
	.fileList{
		width: 400px;
		margin-top: 10px;
		max-height: 400px;
		overflow-y: scroll;
		overflow-x: hidden;
		margin-bottom: 22px;
		overflow-y: scroll;
		box-sizing: border-box;
		.fileItem{
			width: 100%;
			border: 1px solid #ddd;
			padding: 10px 10px;
			height: 80px;
			margin-bottom: 15px;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			.fileIcon{
				width: 50px;
				img{
					width: 100%;
				}
			}
			.fileName{
				margin-left: 10px;
				margin-right: 10px;
				width: 280px;
				line-height: 30px;
				height: 30px;
				overflow: hidden;
			}
			i{
				cursor: pointer;
			}
			i:hover{
				color: #BB0000;
			}
		}
	}
</style>
